import { render, staticRenderFns } from "./m-chart-donut.vue?vue&type=template&id=3f1d328d&scoped=true&"
import script from "./m-chart-donut.vue?vue&type=script&lang=js&"
export * from "./m-chart-donut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1d328d",
  null
  
)

export default component.exports